import React from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid/Grid";
import { portfolioAction } from "../../../../actions";

import { withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import PercentageNumber from "../../../UI/PercentageNumber";
import { getValidAdvisorFees } from "../../../../utilities/validators";
import {DownloadPDFButton} from "../../../../containers/HouseholdDetail/components";

const styles = (theme) => ({
  creatableSelectWrapper: {
    "& .MuiInputBase-input": {
      minHeight: 40,
    },
  },
  ctaWrapper: {
    padding: "20px 0",
    textAlign: "right",
    "& button": {
      marginLeft: 20,
    },
  },
  iconContainer: {
    "& text": {
      fontSize: 14,
    },
  },
  onboardingSummaryTable: {
    width: "80%",
    margin: "20px 0",
    background: theme.palette.secondary.offWhite,
    "& th": {
      fontSize: 13,
      color: theme.palette.primary.main,
    },
    "& td": {
      fontSize: 12,
    },
  },
});

class OnboardStrategyChange extends React.Component {
  state = {
    onboardingInstructionModal: false
  };

  onboard = () => {
    const { selectedPortfolio, dispatch } = this.props;

    dispatch(
      portfolioAction.onboardStrategyChange({
        portfolioId: selectedPortfolio.uuid,
      })
    );
  };

  onCloseOnboardingInstruction = () => {
    this.props.onClose();
    if (this.props.callbacks) {
      this.props.callbacks();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { quik, dispatch, onClose, custodianMap, hideCloseBtn, selectedPortfolio } = this.props;

    if (quik.pending && !nextProps.quik.pending && !nextProps.quik.error) {
      if (
        nextProps.quik.onboardStyle === 'do' &&
        nextProps.quik.appUrl &&
        nextProps.quik.doSessionId
      ) {
        let doRoute = `/Portal/household/${
          this.props.household.currentHousehold.id
        }/onboard/${nextProps.quik.doSessionId}`;

        if (nextProps.quik.portfolioIds.length === 1) {
          doRoute += `?portfolioId=${nextProps.quik.portfolioIds[0]}`
        }
        this.props.history.push(doRoute);
      }

      if (
        nextProps.quik.onboardStyle !== 'do' &&
        nextProps.quik.html &&
        nextProps.quik.id
      ) {
        const quikId = nextProps.quik.id;
        window.localStorage.setItem('quikform', JSON.stringify(nextProps.quik));
        const tab = window.open(`/Portal/onboard?quikId=${encodeURIComponent(quikId)}`, '_blank');
        if (!tab) {
          console.log('popup blocked')
          // window.location.href = `/Portal/onboard?quikId=${encodeURIComponent(quikId)}`;
        }
      }
      dispatch(portfolioAction.resetQuikFormData());

      const custodian = custodianMap[selectedPortfolio];
      if (
        custodian &&
        custodian.onboardingInstruction.enabled &&
        custodian.onboardingInstruction.strategyChangeOnboardingContent
      ) {
        this.setState({onboardingInstructionModal: true})
        hideCloseBtn();
      } else {
        onClose();
        if (this.props.callbacks && nextProps.quik.onboardStyle !== 'do') {
          this.props.callbacks();
        }
      }
    }
  }

  render() {

    const { 
      selectedPortfolio,
      classes,
      quik,
      portfolioAdvisorFeeRates,
      advisorFeeRate,
      advisorDefaultFeeRate,
      custodianMap,
      household,
    } = this.props;

    const { onboardingInstructionModal } = this.state;

    const fees = getValidAdvisorFees(
      portfolioAdvisorFeeRates[selectedPortfolio.uuid],
      advisorFeeRate,
      advisorDefaultFeeRate
    );

    const custodian = custodianMap[selectedPortfolio.CustodianId];
    const instructionContent =
      custodian &&
      custodian.onboardingInstruction.enabled &&
      custodian.onboardingInstruction.strategyChangeOnboardingContent;

    if (onboardingInstructionModal && instructionContent) {
      return <React.Fragment>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              dangerouslySetInnerHTML={{ __html: instructionContent}}
              paragraph={true}
            />
            <DownloadPDFButton
              householdId={household.currentHousehold.id}
              portfolioIds={[selectedPortfolio.uuid]}
              labelText={"Download Cy Summary PDF"}
            />
          </Grid>
        </Grid>
        <div className={classes.ctaWrapper}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onCloseOnboardingInstruction}
          >
            Confirm and Close
          </Button>
        </div>
      </React.Fragment>
    }

    return (
      <React.Fragment>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant={"caption"}>Account Holder</Typography>
                <Typography variant={"body1"}>
                  {selectedPortfolio.Household.name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={"caption"}>Portfolio Name</Typography>
                <Typography variant={"body1"}>
                  {selectedPortfolio.name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={"caption"}>Strategy</Typography>
                <Typography variant={"body1"}>
                  {selectedPortfolio.cprRecommendation.displayName}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant={"caption"}>Advisor Fee</Typography>
                <Typography variant={"body1"}>
                  <PercentageNumber
                    value={fees}
                    needCalculation={false}
                  />
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/*<Grid item xs={12}><Divider style={{margin: '20px 0'}} /></Grid>*/}
          {/*<Grid item xs={5}>*/}
          {/*  <Typography variant={"caption"} gutterBottom>Disclosure Documents</Typography>*/}
          {/*  <Typography variant={"body1"} gutterBottom>*/}
          {/*    Please note, as the introducing advisor these disclosure documents should be sent to your client.<br/><br/>*/}
          {/*  </Typography>*/}
          {/*  <EmailDisclosure onEmailed={this.enableAcknowledgementCheckbox}/>*/}
          {/*  <DownloadDisclosure onDownloaded={this.enableAcknowledgementCheckbox} />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={1}/>*/}
          {/*<Grid item xs={6}>*/}
          {/*  <Acknowledgement onChange={this.setAcknowledged} disabled={!allowAcknowledgement}/>*/}
          {/*</Grid>*/}
        </Grid>
        <div className={classes.ctaWrapper}>
          <Button
            onClick={this.props.onClose}
            variant="outlined"
            color="primary"
            disabled={quik.pending}
          >
            {" "}
            Back{" "}
          </Button>
          <Button
            disabled={quik.pending}
            onClick={this.onboard}
            variant={"contained"}
            color={"primary"}
          >
            {!quik.pending ? (
              "Confirm and Onboard"
            ) : (
              <CircularProgress size={20} />
            )}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { portfolioAdvisorFeeRates, advisorFeeRate, advisorDefaultFeeRate } = state.fee;
  const custodianMap = state.custodian.map;
  const custodians = Object.values(custodianMap).sort(function (a, b) {
    if (a.name > b.name) return 1;
    else if (a.name < b.name) return -1;
    else return 0;
  });
  const quik = state.quik;
  return {
    quik,
    household: state.household,
    portfolioAdvisorFeeRates,
    advisorFeeRate,
    advisorDefaultFeeRate,
    custodians,
    custodianMap
  };
};

export default withStyles(styles)(
  connect(mapStateToProps)(OnboardStrategyChange)
);



// WEBPACK FOOTER //
// ./src/components/OnboardPortfoliosDialog/components/OnboardStrategyChange/index.jsx